import * as React from "react";

const CoralLeftSVG = ({ width = 80, style }) => {
  return (
    <svg
      width={width}
      height={width * 5}
      viewBox="0 0 200 1000"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_2309_110)">
        <path
          d="M120.657 197.82C114.432 195.955 107.273 193.811 100.893 191.899C103.232 184.09 105.899 175.188 98.189 168.113C71.8444 153.074 68.5364 140.34 68.4016 130.599C68.3435 126.327 73.7896 122.171 77.5798 128.242C84.2071 140.609 82.2078 152.945 98.4878 154.078C102.614 151.059 92.7061 139.411 89.0973 135.607C76.7052 113.003 85.9232 106.574 88.943 106.117C96.6324 105.357 94.0717 119.567 94.6454 123.313C98.7458 138.497 105.814 135.849 108.701 122.248C106.766 103.798 116.802 109.357 117.921 112.415C121.557 122.354 116.571 132.774 112.177 140.648C108.67 148.958 112.027 158.133 113.457 161.285C114.672 186.667 126.966 162.608 127.686 155.676C127.739 145.31 125.23 139.616 127.668 132.525C134.248 113.392 144.732 123.68 140.961 130.039C141.116 130.312 135.757 135.628 135.71 141.911C135.501 169.59 142.593 156.057 144.326 153.342C146.881 149.342 149.788 129.449 154.959 123.51C161.54 115.951 167.894 124.897 164.184 131.209C153.809 148.86 157.225 155.463 168.253 147.064C172.427 143.885 177.943 134.529 182.703 136.757C188.355 139.401 185.235 145.854 183.069 149.12C181.716 151.161 175.284 156.995 165.352 160.147C127.898 167.989 147.379 178.25 162.263 172.156C167.868 169.861 175.115 164.353 177.038 164.158C182.984 163.556 185.582 167.906 183.505 170.354C168.542 187.993 155.24 183.712 140.513 182.49C127.937 181.446 123.605 187.977 120.657 197.82Z"
          fill="url(#paint0_linear_2309_110)"
        />
        <path
          d="M110.138 233.741C146.745 232.684 147.071 190.573 92.8584 189.475C100.743 189.019 92.0457 162.496 68.0649 163.341C77.2258 158.727 72.4494 142.842 55.4976 136C38.5457 129.158 -10.2524 125.52 -31.7524 195.242C-39.5471 220.52 -36.0549 240.387 27.7579 254.93C33.8227 256.312 44.4175 252.021 52.5497 254.871C78.891 264.101 96.0891 253.872 79.7129 244.679C114.772 258.874 131.653 244.105 110.138 233.741Z"
          fill="url(#paint1_linear_2309_110)"
        />
        <path
          d="M49.8141 185.605C48.7452 195.894 88.4984 198.198 94.623 186.738C95.6919 176.449 82.8204 165.644 71.8188 165.608C60.8171 165.572 50.883 175.316 49.8141 185.605Z"
          fill="url(#paint2_linear_2309_110)"
        />
        <path
          d="M89.8218 217.949C88.7253 228.504 131.555 234.949 133.322 217.949C134.418 207.395 124.273 196.976 114.322 196.944C104.371 196.911 90.9184 207.395 89.8218 217.949Z"
          fill="url(#paint3_linear_2309_110)"
        />
        <path
          d="M19.9823 195.205C19.7067 203.758 43.5535 200.46 46.8102 190.29C47.0858 181.737 41.1538 172.084 34.5755 173.489C27.9971 174.894 20.258 186.652 19.9823 195.205Z"
          fill="url(#paint4_linear_2309_110)"
        />
        <path
          d="M107.455 240.463C107.731 249.016 83.884 245.718 80.6273 235.548C80.3517 226.995 86.2837 217.342 92.862 218.747C99.4404 220.152 107.18 231.91 107.455 240.463Z"
          fill="url(#paint5_linear_2309_110)"
        />
        <path
          d="M44.2237 157.069C42.7756 163.95 63.8593 165.625 68.1134 157.977C69.5614 151.095 65.7981 142.19 59.912 142.129C54.0258 142.069 45.6718 150.187 44.2237 157.069Z"
          fill="url(#paint6_linear_2309_110)"
        />
        <path
          d="M27.467 234.581C25.7313 251.288 69.3117 254.961 76.6696 236.343C78.4053 219.637 64.8427 202.115 52.749 202.075C40.6554 202.036 29.2027 217.874 27.467 234.581Z"
          fill="url(#paint7_linear_2309_110)"
        />
        <path
          d="M134.641 630.582C146.451 630.23 146.8 597.736 158.9 600.806C177.743 605.586 169.624 632.889 139.785 640.672C124.307 644.709 125.826 656.976 124.525 672.46C115.93 669.067 112.811 667.836 109.588 666.564C110.716 663.021 108.063 655.583 104.037 648.283C96.8326 635.218 75.5641 626.189 80.0131 616.962C82.1351 612.561 102.096 622.3 110.972 641.323C112.396 639.477 96.2735 619.382 93.5557 612.835C89.8528 603.914 87.9104 590.686 97.6044 589.046C108.359 588.399 105.519 622.171 116.311 622.353C122.286 625.427 113.736 585.43 130.895 580.204C144.134 576.171 146.042 598.119 139.112 604.688C128.874 614.391 135.422 625.469 134.641 630.582Z"
          fill="url(#paint8_radial_2309_110)"
        />
        <path
          d="M100.405 678.186C96.3558 681.937 86.561 683.576 81.2076 679.365C75.8543 675.153 76.9697 666.687 81.0191 662.937C88.0796 656.397 94.3202 658.05 99.6735 662.261C105.027 666.472 104.455 674.436 100.405 678.186Z"
          fill="#0B7466"
        />
        <path
          d="M138.819 677.003C134.77 680.753 124.975 682.392 119.622 678.181C114.268 673.97 115.384 665.504 119.433 661.753C126.494 655.214 132.734 656.867 138.088 661.078C143.441 665.289 142.869 673.252 138.819 677.003Z"
          fill="#007867"
        />
        <path
          d="M105.155 649.698C106.868 653.824 102.992 662.516 97.1644 664.293C91.3367 666.07 85.1192 663.914 82.5922 657.826C79.6058 650.631 82.6071 645.04 88.4348 643.263C94.2625 641.485 103.443 645.572 105.155 649.698Z"
          fill="#165741"
        />
        <path
          d="M142.73 677.726C144.442 681.852 140.566 690.543 134.739 692.32C128.911 694.098 122.693 691.941 120.166 685.853C117.18 678.659 120.181 673.067 126.009 671.29C131.837 669.513 141.017 673.599 142.73 677.726Z"
          fill="#165741"
        />
        <path
          d="M121.491 691.499C117.442 695.249 107.647 696.888 102.294 692.677C96.9403 688.466 98.0557 680 102.105 676.249C109.166 669.71 115.406 671.363 120.759 675.574C126.113 679.785 125.54 687.748 121.491 691.499Z"
          fill="#0A8877"
        />
        <path
          d="M120.178 660.87C122.093 665.482 119.002 673.423 112.009 675.556C105.016 677.688 96.7679 673.204 94.8536 668.593C91.5158 660.552 96.2863 656.658 103.28 654.525C110.273 652.393 118.264 656.258 120.178 660.87Z"
          fill="#1D654D"
        />
        <path
          d="M67.5736 650.756C71.1048 646.824 80.4725 644.55 86.1601 648.28C91.8477 652.01 91.7013 660.331 88.1701 664.263C82.0131 671.119 75.7448 669.941 70.0572 666.211C64.3696 662.482 64.0424 654.688 67.5736 650.756Z"
          fill="#0B7466"
        />
        <path
          d="M30.2572 654.565C33.7884 650.633 43.1561 648.359 48.8437 652.089C54.5313 655.819 54.3849 664.139 50.8537 668.072C44.6967 674.928 38.4284 673.75 32.7408 670.02C27.0532 666.29 26.726 658.497 30.2572 654.565Z"
          fill="#007867"
        />
        <path
          d="M66.1064 678.828C63.9777 674.929 66.7906 666.198 72.275 664.064C77.7595 661.931 84.0613 663.6 87.2018 669.353C90.9134 676.152 88.6087 681.804 83.1242 683.938C77.6398 686.071 68.2351 682.728 66.1064 678.828Z"
          fill="#165741"
        />
        <path
          d="M26.3603 654.129C24.2316 650.23 27.0445 641.499 32.5289 639.365C38.0134 637.231 44.3152 638.901 47.4557 644.654C51.1673 651.453 48.8626 657.105 43.3781 659.238C37.8937 661.372 28.489 658.028 26.3603 654.129Z"
          fill="#165741"
        />
        <path
          d="M45.5384 639.252C49.0696 635.32 58.4374 633.046 64.1249 636.776C69.8125 640.506 69.6662 648.827 66.135 652.759C59.978 659.615 53.7096 658.437 48.022 654.707C42.3345 650.978 42.0072 643.184 45.5384 639.252Z"
          fill="#0A8877"
        />
        <path
          d="M50.2183 668.987C47.8391 664.629 49.9693 656.683 56.5507 654.122C63.132 651.562 71.6722 655.357 74.0514 659.715C78.1996 667.314 73.9812 671.435 67.3999 673.996C60.8185 676.556 52.5974 673.345 50.2183 668.987Z"
          fill="#1D654D"
        />
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_2309_110"
          x1={137.029}
          y1={113.528}
          x2={112.51}
          y2={195.379}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#545E30" />
          <stop offset={1} stopColor="#09635F" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_2309_110"
          x1={-20.0639}
          y1={117.194}
          x2={-47.5424}
          y2={237.769}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008D84" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <linearGradient
          id="paint2_linear_2309_110"
          x1={74.3541}
          y1={165.616}
          x2={74.2602}
          y2={194.385}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009085" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <linearGradient
          id="paint3_linear_2309_110"
          x1={115.196}
          y1={200.304}
          x2={115.1}
          y2={229.816}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009085" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <linearGradient
          id="paint4_linear_2309_110"
          x1={33.947}
          y1={175.66}
          x2={38.7965}
          y2={198.368}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009085" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <linearGradient
          id="paint5_linear_2309_110"
          x1={93.4905}
          y1={220.918}
          x2={88.641}
          y2={243.626}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009085" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <linearGradient
          id="paint6_linear_2309_110"
          x1={59.0616}
          y1={143.774}
          x2={58.8623}
          y2={163.05}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009085" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <linearGradient
          id="paint7_linear_2309_110"
          x1={58.6594}
          y1={195.09}
          x2={50.8955}
          y2={236.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A295" />
          <stop offset={1} stopColor="#145F53" />
        </linearGradient>

        <radialGradient
          id="paint8_radial_2309_110"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-13.7246 43.1129 -39.3389 -15.5282 122.29 623.047)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B6B59" />
          <stop offset={1} stopColor="#187C54" />
        </radialGradient>

        <clipPath id="clip0_2309_110">
          <rect width={200} height={1000} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(CoralLeftSVG, (prev, next) => prev.width === next.width);
